import styled from "styled-components";

const UtilDiv = styled.div`
  height: 56px;
  // background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
`;

export default UtilDiv;
